export type Scores = { [rosterId: string]: number };

export const hasScore = (scores: Scores | undefined) => {
  if (!scores) {
    return false;
  }

  return Object.values(scores).some((s) => !!s);
};

export const applyScoreOverrides = (
  scores: Scores,
  scoreOverrides: Scores | undefined
) => {
  if (!scoreOverrides) {
    return scores;
  }

  Object.keys(scoreOverrides).forEach((rosterId) => {
    const scoreOverride = scoreOverrides[rosterId];
    if (scoreOverride !== undefined) {
      scores[rosterId] = scoreOverride;
    }
  });

  return scores;
};

export const getSumOfOtherScores = (scores: Scores, rosterId: string) => {
  const otherRosterIds = Object.keys(scores).filter((id) => id !== rosterId);
  return otherRosterIds.reduce((sum, id) => sum + (scores[id] ?? 0), 0);
};
